<template>
	<div class="change-password-form">
		<required-field
			:error="$v.password.$error"
			:required="$v.password.required"
			label="New password"
		>
			<p class="is-size-7 mb-3">
				Choose a password with eight characters or more. For a strong password,
				use a combination of lowercase and uppercase letters, numbers and
				special characters
			</p>
			<input
				v-model.trim="$v.password.$model"
				class="input"
				type="password"
				:class="{ 'is-danger': $v.password.$error }"
			/>
			<p v-if="!$v.password.minLength" class="help is-danger">
				Password must have at least {{ $v.password.$params.minLength.min }}
			</p>
		</required-field>
		<required-field
			:error="$v.repeatPassword.$error"
			:required="$v.repeatPassword.required"
			label="Confirm new password"
		>
			<input
				v-model.trim="$v.repeatPassword.$model"
				class="input"
				type="password"
				:class="{ 'is-danger': $v.repeatPassword.$error }"
			/>
			<p v-if="!$v.repeatPassword.sameAsPassword" class="help is-danger">
				Passwords must be identical.
			</p>
		</required-field>
		<div class="change-password-form__actions">
			<button class="button is-white gtm-cancel" @click.prevent="cancel">
				Cancel
			</button>
			<button
				class="button is-link is-outlined gtm-save"
				:class="{ 'is-loading': fetching }"
				@click="submit"
			>
				Update
			</button>
		</div>
		<p v-if="errorMessage" class="help is-danger">
			{{ errorMessage }}
		</p>
		<span class="change-password-form__close">
			<button class="button is-white gtm-close" @click.prevent="cancel">
				<i class="far fa-times"></i>
			</button>
		</span>
	</div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, minLength, sameAs } from "vuelidate/lib/validators";
import { user } from "@lab/api/current.user";

export default {
	name: "FormChangePassword",
	mixins: [validationMixin],
	validations: {
		password: { required, minLength: minLength(8) },
		repeatPassword: { sameAsPassword: sameAs("password") }
	},
	data() {
		return {
			password: "",
			repeatPassword: "",
			fetching: false,
			errorMessage: null,
			successMessage: null
		};
	},
	computed: {
		isValid() {
			return !this.$v.$invalid;
		},
		profileUser() {
			return this.user || this.currentUser;
		}
	},
	methods: {
		async submit() {
			// reset form messages
			this.successMessage = "";
			this.errorMessage = "";

			this.$v.$touch();
			if (this.isValid) {
				this.fetching = true;
				await user.updatePassword(this.profileUser.id, this.password);
				this.password = "";
				this.repeatPassword = "";
				this.$v.$reset();
				this.fetching = false;
				this.$emit("submit");
			}
		},
		cancel() {
			this.$emit("cancel");
			this.$v.$reset();
		}
	}
};
</script>

<style scoped>
.field {
	max-width: 550px;
}
</style>

<style lang="scss">
.change-password-form {
	border: 1px solid $border;
	border-radius: $radius;
	padding: 1.5rem;
	position: relative;

	&__actions {
		border-top: 1px solid $border;
		margin-top: 1.25rem;
		padding-top: 0.75rem;
		text-align: right;
		margin-bottom: 0;

		.button {
			&:not(:last-child) {
				margin-right: 0.5rem;
			}
		}
	}

	&__close {
		position: absolute;
		top: 1.5rem;
		right: 1.5rem;
	}
}
</style>
